import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AwardFuncData } from '@interfaces';
import { StaticDataService } from '../../../../../../services';
import { AcceleratorAreaService } from '../../../accelerator-area.service';
import { AccDeliveryService } from '../../acc-delivery.service';
import { getSetup } from './grid/get-setup';

export interface Award extends AwardFuncData {
	ventureName: string,
	awardName: string,
	kind: string,
	decidedBy: string,
	awardeeNames: string,
	awardeeEmails: string,
}

@Component({
	selector: 'acc-awards-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './awards-view.part.html',
})
export class AccAwardsViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	private readonly staticDataService = inject(StaticDataService);
	private readonly pageService = inject(AccDeliveryService);
	private readonly areaService = inject(AcceleratorAreaService);

	public setup = getSetup(this.util, this.dialogService, this.areaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});


	public awards = computed<Award[]>(() => {
		const data = this.areaService.data();
		if (!data) return [];

		const ventureMap = this.areaService.accVentureMap();
		const entByVenture = this.util.array.toArrayMap(data.entrepreneurs, e => e.accVentureId);

		return data.awards.map(a => {
			const venture = ventureMap[a.accVentureId ?? -1];

			if (!venture) return undefined;

			const entrepreneurs = entByVenture[venture.accVentureId];

			return {
				...a,
				ventureName: venture.ventureName,
				awardName: this.staticDataService.awardnames.byId(a.awardNameId).name,
				kind: this.staticDataService.awardKinds.byId(a.awardKindId).name,
				decidedBy: this.staticDataService.decidingroles.byId(a.decidingRoleId).name,
				awardeeNames: entrepreneurs ? entrepreneurs.map(e => e.fullName).join(', ') : '',
				awardeeEmails: entrepreneurs ? entrepreneurs.map(e => e.email).join(', ') : '',
			}
		}).filter(a => !!a);
	});

}